export default "__VITE_ASSET__C0eTkW13__"